import React from 'react';
import { DetailsHeader } from './DetailsHeader';
import { SharedNotesTimeline } from './SharedNotesTimeline';
import { ValueLabel } from '@shared/components/ValueLabel';
import { PowerOff, Calendar, Info } from 'lucide-react';
import { useRequestDetail } from '../../../shared/hook';
import { getLoginDataFromStorage } from '@shared/utils/loginUtils';
import { useTranslation } from 'react-i18next';

export const DisconnectionDetails = ({ data }: { data: any }) => {
  const { t } = useTranslation();
  const { remoteUtilityId } = getLoginDataFromStorage();
  const { data: requestDetail, isLoading } = useRequestDetail({
    remote_utility_id: remoteUtilityId,
    id: data?.id,
  });

  const details = requestDetail?.result || data;

  if (isLoading) return <div className="p-6 text-center text-slate-500">{t("Loading...")}</div>;

  return (
    <div className="flex flex-col h-full bg-slate-50/50 pb-6">
      <DetailsHeader 
        icon={<PowerOff size={18} />}
        iconBgColor="bg-red-100"
        iconTextColor="text-red-600"
        title={details?.utilitySupportRequest?.name || t("Temporary Disconnection")}
        status={details?.statusDisplay}
        id={details?.requestNo ?? t("N/A")}
        submittedDate={details?.createdDate ? new Date(details.createdDate).toLocaleDateString() : t("N/A")}
      />
      <div className="p-6 space-y-4">
        {/* DISCONNECTION & SCHEDULE */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white border border-gray-200 rounded-xl p-5">
            <h4 className="text-sm font-semibold text-gray-800 flex items-center gap-2 mb-4"><PowerOff size={16}/> {t("Disconnection")}</h4>
            <div className="space-y-4">
              <ValueLabel label={t("Reason")} value={details?.utilitySupportRequest?.supportRequestType || t("Renovation")} />
              <ValueLabel label={t("Disconnection Date")} value={details?.requestDate ? new Date(details.requestDate).toLocaleDateString() : t("N/A")} />
            </div>
          </div>
          <div className="bg-white border border-gray-200 rounded-xl p-5">
            <h4 className="text-sm font-semibold text-gray-800 flex items-center gap-2 mb-4"><Calendar size={16}/> {t("Schedule")}</h4>
            <div className="space-y-4">
              <ValueLabel label={t("Submitted")} value={details?.createdDate ? new Date(details.createdDate).toLocaleDateString() : t("N/A")} />
              <ValueLabel label={t("Preferred Time Slot")} value={details?.prefferedTimeSlotDisplay || '—'} />
            </div>
          </div>
        </div>

        {/* ADDITIONAL NOTES */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h4 className="text-sm font-semibold text-gray-800 flex items-center gap-2 mb-3"><Info size={16}/> {t("Additional Notes")}</h4>
          <p className="text-sm text-gray-700 leading-relaxed">{details?.utilitySupportRequest?.longDescription || t("No additional notes provided.")}</p>
        </div>

        {/* TABS */}
        <SharedNotesTimeline data={data} />
      </div>
    </div>
  );
};
